module.exports = __webpack_public_path__ + "static/media/yearnfinance.c69913c1.png";